import React, { useState, useEffect } from 'react';
import {
  Card,
  Row,
  Col,
  Spin,
  Button,
  Icon,
} from 'antd';
import { connect } from 'react-redux';
import {
  withRouter,
} from 'react-router-dom';
import moment from 'moment-timezone';
import styled from 'styled-components';
import { lynxConnectActions, lynxTenantDetailActions } from 'store/actions';
import { SpH5 } from 'components/DesignKit';
import RBAC from 'components/rbac';
import currencyformatter from 'utils/currencyformatter';
import {
  ROLES,
  LYNX_CONNECT,
} from 'appconstants';
import ActivityLogTimeline from './components/Timeline';
import ViewInvoice from './components/ViewPdf';

type Props = {
  // loading: Boolean,
  selectedAccount: Object,
  test: Boolean,
  location: {
    pathname: string,
    search: string,
  },
  // history: {
  //   push: Function,
  //   replace: Function,
  // };
  lynxTenantDetails: Array,
  lynxConnectLoading: Boolean,
  fetchLynxTenantDetails: Function,
  lyxnConnectInvoiceDetail: {
    vendorName: String | null,
    invoiceNumber: String | null,
    totalAmount: String | null,
    billedTo: String | null,
    invoiceDate: String | null,
    subTotalAmount: String | null,
    fileName: String | null,
    status: String | null,
    scanDate: String | null,
    locatoin: String | null,
  },
  fetchInvoiceDetail: Function,
  fetchInvoicePdf: Function,
  lynxConnectInvoicePdf: Array,
  lynxConnectSubLoading: {
    invoiceDetail: Boolean,
    pdfData: Boolean,
    auditTimeline: Boolean,
  },
  setInvoicePdf: Function,
  fetchActivityLog: Function,
  lynxConnectAuditLogTimeline: Array,
  requestApproval: Function,
  existUpdatePos: Function,
  setPosStatus: Function,
  // lynxConnectUpdatePosStatus: String,
};

const PageCard = styled(Card)`
  padding: 0 !important;
  .ant-card-body {
    padding-top: 0 !important;
  }
`;

const ShadowRow = styled(Row)`
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  border: 0px;
  margin-left: 0px !important;
  margin-right: 0px !important;
`;

const ShadowCard = styled(Card)`
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  max-height: 500px;
  overflow: hidden;
`;

const OverflowCol = styled(Col)`
  max-height: 460px;
  overflow: auto;
`;

const ActivityLog = (props: Props) => {
  const {
  // loading: Boolean,
    selectedAccount,
    test,
    location,
    // history,
    lynxTenantDetails,
    lynxConnectLoading,
    fetchLynxTenantDetails,
    lyxnConnectInvoiceDetail,
    fetchInvoiceDetail,
    fetchInvoicePdf,
    lynxConnectInvoicePdf,
    lynxConnectSubLoading,
    setInvoicePdf,
    fetchActivityLog,
    lynxConnectAuditLogTimeline,
    requestApproval,
    existUpdatePos,
    setPosStatus,
    // lynxConnectUpdatePosStatus,
  } = props;

  useEffect(() => {
    fetchLynxTenantDetails({});
    // clear pdfData
    setInvoicePdf('');
  }, []);

  const [viewPdf, setViewPdf] = useState(false);

  const getData = (invoiceGid) => {
    // fetch the acitvity log details
    fetchInvoiceDetail({
      gid: invoiceGid,
    });
    fetchInvoicePdf({
      gid: invoiceGid,
    });
    fetchActivityLog({
      gid: invoiceGid,
    });
  };

  useEffect(() => {
    if (/^\/lynxconnect\/activity-log\/[^/]+$/.test(location.pathname)) {
      getData(location.pathname.split('/').slice(-1)[0]);
    }
  }, [location.search, test, selectedAccount]);

  if (Array.isArray(lynxTenantDetails)
    && lynxTenantDetails.length === 0
  ) {
    return <></>;
  }

  const presetCurrencyFromatter = (value) => currencyformatter(Number(value / 100), selectedAccount?.currency?.name);

  const handleRequestButton = () => {
    if (/^\/lynxconnect\/activity-log\/[^/]+$/.test(location.pathname)) {
      requestApproval({
        gid: location.pathname.split('/').slice(-1)[0],
        existLineItemPage: false,
      });
    }
  };

  const handleApproveButton = () => {
    if (/^\/lynxconnect\/activity-log\/[^/]+$/.test(location.pathname)) {
      existUpdatePos({
        invoiceGid: location.pathname.split('/').slice(-1)[0],
        existLineItemPage: false,
      });
    }
    setPosStatus('');
  };

  const handleViewPdfButton = () => {
    setViewPdf(true);
  };

  const formatStatus = (status) => {
    let formattedStatus = '';
    switch (status) {
      case LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS:
        formattedStatus = LYNX_CONNECT.INVOICE_STATUS_FORMATTED.READY_TO_PROCESS;
        break;
      case LYNX_CONNECT.INVOICE_STATUS.ANALYSING:
        formattedStatus = LYNX_CONNECT.INVOICE_STATUS_FORMATTED.ANALYSING;
        break;
      case LYNX_CONNECT.INVOICE_STATUS.PROCESSED:
        formattedStatus = LYNX_CONNECT.INVOICE_STATUS_FORMATTED.PROCESSED;
        break;
      case LYNX_CONNECT.INVOICE_STATUS.WAITING_FOR_APPROVAL:
        formattedStatus = LYNX_CONNECT.INVOICE_STATUS_FORMATTED.WAITING_FOR_APPROVAL;
        break;
      default:
        formattedStatus = '';
    }
    return formattedStatus;
  };

  const formatDate = (date) => {
    if (selectedAccount && selectedAccount.timezone) {
      return moment
        .utc(date)
        .tz(selectedAccount.timezone)
        .format('MMM DD, YYYY, hh:mm a');
    }
    return '';
  };

  return (
    <PageCard bodyStyle={{ padding: 0 }}>
      <RBAC permit={
        [ROLES.ADMINISTRATOR,
          ROLES.OWNER,
          ROLES.DEVELOPER,
          ROLES.OPERATIONS,
          // ROLES.ANALYST,
          ROLES.SUPPORT,
          ROLES.INTERNALSUPPORT,
          ROLES.POS,
          ROLES.SUPERUSER,
          ROLES.ONBOARDING,
          ROLES.OFFICEMANAGER,
          ROLES.OFFICESUPPORT,
          ROLES.WAREHOUSE_ASSOCIATE,
          ROLES.PRICING_ANALYST,
        ]
            }
      >
        <Spin
          spinning={lynxConnectLoading}
          tip="Please wait..."
          size="large"
          delay={300}
        >
          <ShadowRow gutter={16} type="flex" className="mb-4 p-3">
            <Col>
              <SpH5>File Name: {lyxnConnectInvoiceDetail?.fileName}</SpH5>
            </Col>
            <Col>
              <SpH5>Scan Date: {formatDate(lyxnConnectInvoiceDetail?.scanDate)}</SpH5>
            </Col>
            <Col>
              <SpH5>Status: {formatStatus(lyxnConnectInvoiceDetail?.status)}</SpH5>
            </Col>
          </ShadowRow>
          <Row
            gutter={16}
            type="flex"
            justify="end"
            className="mb-3 pr-3"
          >
            <Col>
              <Button
                type="secondary"
                shape="round"
                onClick={handleViewPdfButton}
              >
                View PDF
              </Button>
            </Col>
            <RBAC
              permit={[
                ROLES.OWNER,
                ROLES.SUPERUSER,
                ROLES.INTERNALSUPPORT,
                ROLES.ONBOARDING,
                ROLES.WAREHOUSE_ASSOCIATE,
                ROLES.PRICING_ANALYST,
              ]}
            >
              {
                lyxnConnectInvoiceDetail?.status === LYNX_CONNECT.INVOICE_STATUS.READY_TO_PROCESS && (
                  <Col>
                    <Button
                      type="primary"
                      shape="round"
                      onClick={handleRequestButton}
                    >
                      Request Approval
                    </Button>
                  </Col>
                )
              }
            </RBAC>
            <RBAC
              permit={[
                ROLES.OWNER,
                ROLES.SUPERUSER,
                ROLES.INTERNALSUPPORT,
                ROLES.ONBOARDING,
                ROLES.PRICING_ANALYST,
              ]}
            >
              {
                lyxnConnectInvoiceDetail?.status === LYNX_CONNECT.INVOICE_STATUS.WAITING_FOR_APPROVAL && (// change
                  <Col>
                    <Button
                      type="primary"
                      shape="round"
                      onClick={handleApproveButton}
                    >
                      Approve
                    </Button>
                  </Col>
                )
              }
            </RBAC>
          </Row>
          <Row gutter={16} className="p-4">
            <Col span={8}>
              <Spin
                spinning={lynxConnectLoading ? false : lynxConnectSubLoading.invoiceDetail}
                tip="Please wait..."
                size="large"
                delay={300}
              >
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>Vendor Name: {lyxnConnectInvoiceDetail?.vendorName}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>Invoice Number: {lyxnConnectInvoiceDetail?.invoiceNumber}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>Invoice Date: {lyxnConnectInvoiceDetail?.invoiceDate}
                    </SpH5>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>Billed To: {lyxnConnectInvoiceDetail?.billedTo}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>File Name: {lyxnConnectInvoiceDetail?.fileName}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>Location: {lyxnConnectInvoiceDetail?.location}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>Sub Total Amount: {presetCurrencyFromatter(lyxnConnectInvoiceDetail?.subTotalAmount)}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col span={24}>
                    <SpH5>Total Amount: {presetCurrencyFromatter(lyxnConnectInvoiceDetail?.totalAmount)}</SpH5>
                  </Col>
                </Row>
                {/* <Row className="mb-2">
                  <Col span={24}>
                    <u><SpH5>Initial Status</SpH5></u>
                  </Col>
                </Row>
                <Row className="mb-1">
                  <Col span={24}>
                    <SpH5>No. of New Items: {}</SpH5>
                  </Col>
                </Row>
                <Row className="mb-4">
                  <Col span={24}>
                    <SpH5>No. of Existing Items: {}</SpH5>
                  </Col>
                </Row>
                {
                  lyxnConnectInvoiceDetail?.status === LYNX_CONNECT.INVOICE_STATUS.PROCESSED && ( // check spelling
                    <>
                      <Row className="mb-2">
                        <Col>
                          <u><SpH5>Final Status</SpH5></u>
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col span={24}>
                          <SpH5>No. of New Items: {}</SpH5>
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col span={24}>
                          <SpH5>No. of Existing Items: {}</SpH5>
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col span={24}>
                          <SpH5>No. Of Items Synced: {}</SpH5>
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col span={24}>
                          <SpH5>Total Gross Profit: {}</SpH5>
                        </Col>
                      </Row>
                      <Row className="mb-1">
                        <Col span={24}>
                          <SpH5>Total Gross Profit Margin: {}</SpH5>
                        </Col>
                      </Row>
                    </>
                  )
                } */}
              </Spin>
            </Col>
            <Col span={16}>
              <Spin
                spinning={lynxConnectSubLoading.auditTimeline}
                tip="Please wait..."
                size="large"
                delay={300}
              >
                <ShadowCard>
                  <Row
                    gutter={16}
                    type="flex"
                    className="mb-4 mt-3"
                  >
                    <Col>
                      <Icon type="history" />
                    </Col>
                    <Col>
                      <SpH5>Timeline</SpH5>
                    </Col>
                  </Row>
                  <Row gutter={16}>
                    <OverflowCol span={24} className="pt-2">
                      <ActivityLogTimeline
                        selectedAccount={selectedAccount}
                        timelineDetail={lynxConnectAuditLogTimeline ?? []}
                      />
                    </OverflowCol>
                  </Row>
                </ShadowCard>
              </Spin>
            </Col>
          </Row>
          <ViewInvoice
            pdfName={lyxnConnectInvoiceDetail?.fileName ?? ''}
            pdfData={lynxConnectInvoicePdf ?? new ArrayBuffer('')}
            showPdfCard={viewPdf}
            setShowPdfCard={setViewPdf}
            loading={lynxConnectSubLoading.pdfData}
          />
        </Spin>
      </RBAC>
    </PageCard>
  );
};

const mapStateToProps = state => ({
  loading: state.loading.loading,
  validator: state.loading.validator,
  selectedAccount: state.account.selectedAccount,
  submitting: state.loading.submitting,
  test: state.account.test,
  lynxTenantDetails: state.lynxTenantDetails.lynxTenantDetails,
  // add state to get value of fetch invoice details here
  lynxConnectLoading: state.lynxConnect.loading,
  lynxConnectSubLoading: state.lynxConnect.subLoading,
  lyxnConnectInvoiceDetail: state.lynxConnect.invoices.invoiceDetail,
  lynxConnectInvoicePdf: state.lynxConnect.pdf,
  lynxConnectAuditLogTimeline: state.lynxConnect.auditLogTimeline,
  lynxConnectUpdatePosStatus: state.lynxConnect.exist.posStatus,
});

const mapDispatchToProps = dispatch => ({
  // add a function to dispatch the fetching of activity log
  fetchActivityLog: param => dispatch(lynxConnectActions.fetchAutditLog({
    payload: param,
  })),
  requestApproval: param => dispatch(lynxConnectActions.requestApproval({
    payload: param,
  })),
  existUpdatePos: param => dispatch(lynxConnectActions.existUpdatePos({
    payload: param,
  })),
  setPosStatus: param => dispatch(lynxConnectActions.setPosStatus({
    payload: param,
  })),
  fetchLynxTenantDetails: param => dispatch(lynxTenantDetailActions.fetchLynxTenantDetails({
    payload: param,
  })),
  fetchInvoiceDetail: param => dispatch(lynxConnectActions.fetchInvoiceDetail({
    payload: param,
  })),
  fetchInvoicePdf: param => dispatch(lynxConnectActions.fetchInvoicePdf({
    payload: param,
  })),
  setInvoicePdf: param => dispatch(lynxConnectActions.setInvoicePdf({
    payload: param,
  })),
});

// $FlowFixMe
export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ActivityLog));
